import { LogOut } from 'lucide-react';
import { ModalBackdrop } from '../common';

function ConfirmationModal({
  confirmLabel = 'Confirm',
  description,
  isOpen,
  onCancel,
  onConfirm,
  title,
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <ModalBackdrop
      backdropClassName="bg-[rgba(33,27,22,0.18)] backdrop-blur-[2px]"
      contentClassName="items-center"
    >
      <div className="w-full max-w-sm overflow-hidden rounded-[24px] border border-[var(--theme-border-soft)] bg-white shadow-[0_22px_60px_rgba(var(--theme-shadow-rgb),0.14)]">
        <div className="border-b border-[var(--theme-border-soft)] bg-white px-5 py-5">
          <div className="flex items-start gap-4">
            <div className="grid h-12 w-12 shrink-0 place-items-center rounded-[16px] bg-[var(--theme-accent-soft)] text-[var(--theme-accent)]">
              <LogOut className="h-5 w-5" />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="m-0 text-[1.05rem] font-semibold tracking-[-0.03em] text-[var(--theme-text)]">
                {title}
              </h3>
              <p className="mt-2 text-[0.9rem] leading-6 text-[var(--theme-text-subtle)]">{description}</p>
            </div>
          </div>
        </div>

        <div className="grid gap-2.5 px-5 py-5 sm:grid-cols-2">
          <button
            className="rounded-full border border-[var(--theme-border)] bg-white px-4 py-2.5 text-[0.88rem] font-semibold text-[var(--theme-text-subtle)] transition hover:bg-[var(--theme-surface-soft)]"
            onClick={onCancel}
            type="button"
          >
            Cancel
          </button>
          <button
            className="rounded-full bg-[var(--theme-accent)] px-4 py-2.5 text-[0.88rem] font-semibold text-white transition hover:bg-[var(--theme-accent-strong)]"
            onClick={onConfirm}
            type="button"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </ModalBackdrop>
  );
}

export default ConfirmationModal;
